module.exports = __webpack_public_path__ + "img/reload-light.4bbdfc2f.svg";